<template>
    <div>
        <a-modal @cancel="hide" class="w1049_ modal_" :footer="false" :visible="visible" :title="$t('addPolicy.e6')">
            <tbsm :lang="lang"/>
            <p class="btn_wrap_">
                <a-button @click="hide(1)" type="primary">{{$t('buttons.c')}}</a-button>
            </p>
        </a-modal>
    </div>
</template>
<style lang="scss" scoped>
    .btn_wrap_ {
        display: flex;
        justify-content: center;
    }
</style>
<script>
let cPath = '';
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        lang: {
            type: Number,
            default: 1
        },
        p: {
            type: String,
            default: ''
        }
    },
    components: {
        tbsm: function () {
            return import(`./${cPath}tbsm.vue`);
        }
    },
    data () {
        cPath = this.p;
        return {
        }
    },
    methods: {
        hide (confirm) {
            this.$emit('update:visible', false)
            typeof confirm == 'number' && this.$emit('confirm')
        }
    }
}
</script>